import { config } from "../../env";

export function authHeader(url) {
  // return authorization header with jwt token
  // client.dev.ascentcompliance.in
  // ascent.lexcare.in
  // indegene.lexcare.in
  let access_token = localStorage.getItem("accessToken");
  let port = window.location.origin.split("//")[1].split(":")[0];
  console.log(
    "rrrrrrrrrrrrrrrrrrrr1111111111111",
    port,
    window.location.origin
  );
  let getOriginString = port.split(".");
  const str = window.location.origin;
  const urls = str.split("://")[1];
  let domain = urls.split(".")[0];
  const source = urls.replace(".vendor", "").replace("-vendor", "");

  if (access_token) {
    if (url && url.split("/")[3] !== "survey-collector") {
      return {
        Authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        source:
          domain === "accenture"
            ? "ascent.lexcare.in"
            : getOriginString[0] === "localhost" ||
              getOriginString[0] === "client1-qa-vendor"
            ? config.SOURCE
            : source,
      };
    } else {
      return {
        "Content-Type": "application/json",
        source:
          domain === "accenture"
            ? "ascent.lexcare.in"
            : getOriginString[0] === "localhost" ||
              getOriginString[0] === "client1-qa-vendor"
            ? config.SOURCE
            : source,
      };
    }
  } else {
    return {
      "Content-Type": "application/json",
      source:
        domain === "accenture"
          ? "ascent.lexcare.in"
          : getOriginString[0] === "localhost" ||
            getOriginString[0] === "client1-qa-vendor"
          ? config.SOURCE
          : source,
    };
  }
}
